/** "182 W" | "2.34 kW" | "0 W" */
export function formatPower(w: number | null | undefined): string {
  if (w == null || w <= 0) return '0 W'
  if (w >= 1000) return `${(w / 1000).toFixed(2)} kW`
  return `${w.toFixed(1)} W`
}

/** "2.34 kW" always — used in metered breakdowns where the unit is fixed. */
export function formatKW(w: number | null | undefined, digits = 2): string {
  if (w == null) return '—'
  return `${(w / 1000).toFixed(digits)}`
}

/** "1.25" MWh or "—" */
export function formatMWh(wh: number | null | undefined, digits = 2): string {
  if (wh == null) return '—'
  return `${(wh / 1_000_000).toFixed(digits)}`
}

export function shortId(id: string, n = 8): string {
  return id.slice(0, n)
}
